var _rect, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWindiCssDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    fill: "none",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "#242938",
    rx: 60
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_159_879)",
    d: "M132.158 63.1626C132.158 43.7728 116.385 28 96.9951 28C76.5606 28 64.3442 43.3208 64.3442 58.1392H84.437C84.437 53.97 88.3351 48.0928 96.9951 48.0928C105.303 48.0928 112.065 54.8542 112.065 63.1626C112.065 71.471 106 78.2322 90.7067 78.2322H36V98.3251H90.7067C116.518 98.3251 132.158 82.5523 132.158 63.1626ZM132.158 63.1626C132.158 43.7728 116.385 28 96.9951 28C76.5606 28 64.3442 43.3208 64.3442 58.1392H84.437C84.437 53.97 88.3351 48.0928 96.9951 48.0928C105.303 48.0928 112.065 54.8542 112.065 63.1626C112.065 71.471 106 78.2322 90.7067 78.2322H36V98.3251H90.7067C116.518 98.3251 132.158 82.5523 132.158 63.1626Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_159_879)",
    d: "M176.734 192.837C176.734 212.228 160.961 228 141.571 228C121.137 228 108.92 212.68 108.92 197.861H129.013C129.013 202.03 132.911 207.908 141.571 207.908C149.88 207.908 156.641 201.146 156.641 192.837C156.641 184.529 149 177.768 135.283 177.768H74.5762V157.675H135.283C161.094 157.675 176.734 173.448 176.734 192.837ZM176.734 192.837C176.734 212.228 160.961 228 141.571 228C121.137 228 108.92 212.68 108.92 197.861H129.013C129.013 202.03 132.911 207.908 141.571 207.908C149.88 207.908 156.641 201.146 156.641 192.837C156.641 184.529 149 177.768 135.283 177.768H74.5762V157.675H135.283C161.094 157.675 176.734 173.448 176.734 192.837Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear_159_879)",
    d: "M182 59C159.838 59 144.204 75.8538 144.204 98.0162H162C162 87 170 79 182 79C194 79 200 87 200 98.0162C200 109.032 192.207 118.109 171 118.109H36V138.202H174C205.406 138.202 220 118.016 220 98.0162C220 75.8538 205 59 182 59Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint3_linear_159_879)",
    d: "M62.3402 157.675H36V177.936H62.3402V157.675Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_159_879",
    x1: 52,
    x2: 168,
    y1: 45,
    y2: 228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.078,
    stopColor: "#54C8F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#41A2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3386EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_159_879",
    x1: 52,
    x2: 168,
    y1: 45,
    y2: 228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.078,
    stopColor: "#54C8F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#41A2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3386EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_159_879",
    x1: 52,
    x2: 168,
    y1: 45,
    y2: 228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.078,
    stopColor: "#54C8F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#41A2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3386EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_159_879",
    x1: 52,
    x2: 168,
    y1: 45,
    y2: 228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.078,
    stopColor: "#54C8F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#41A2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3386EE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindiCssDark);
export default __webpack_public_path__ + "static/media/WindiCSS-Dark.db96e061a9876819d65aa2b98c2c477a.svg";
export { ForwardRef as ReactComponent };